<template>
  <div class="fivth-bar">
    <div class="grid">
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: item.url },
          })
        "
        v-for="(item, index) in list"
        :key="item.id"
        class="grid__item"
      >
        <div class="card" :class="`card-${index + 1}`">
          <div class="card__img">
            <ImageContainer
              class="img"
              :src="item.image.medium"
              :thumb="item.image.thumbnail"
              :alt="item.title"
            />
          </div>
          <div class="card__descr">
            <div class="overlay">
              <div class="card-top">
                <span class="card__category">{{ item.sub_category.name }}</span>
                <span class="day">{{ handleDate(item.pub_date) }}</span>
              </div>
              <h3 class="card__title limited-text">{{ item.title }}</h3>
              <p
                v-html="changeFirstLetter(item.brief)"
                class="card__brief limited-text"
              ></p>
              <div class="data-news-decr">
                <span class="day">{{ handleDate(item.pub_date) }}</span>
              </div>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";

export default {
  components: { ImageContainer },

  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  setup() {
    return {
      ...useFormatter(),
    };
  },
};
</script>

<style lang="scss" scoped>
.fivth-bar {
  width: 100%;
}
.grid {
  width: 90%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(4, 378px);
  gap: 2rem;

  &__item {
    height: 100%;
  }
}

.card {
  position: relative;
  // height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  &__img {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: -1;
  }
  &__descr {
    position: absolute;
    bottom: 0;
    // margin-top: 20%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 1;
    position: relative;
    width: 100%;
    height: 100%;

    .overlay {
      background: rgba(99, 99, 99, 0.45);
      padding: 1rem 24vw;
      height: 188px;
      margin-top: auto;
    }
  }
  &__category {
    font-size: 1.125em;
  }
  &__title {
    --snup: 2;
    font-size: 1.4em;
    line-height: 1.3;
  }
  &__brief {
    font-size: 1.3em;
    line-height: 145%;
    margin-top: 1rem;
    color: #cdcdcd;
    --snup: 3;
  }
  .data-news-decr {
    display: none;
  }
  .card-top {
    display: flex;
    justify-content: space-between;
    .day {
      font-family: Roboto;
      font-weight: 500;
      font-size: 1em;
      line-height: 1.2;
      /* identical to box height */

      color: rgba(205, 205, 205, 0.5);
    }
  }
}
@media screen and (max-width: 992px) {
  .grid {
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: auto;
    gap: 0;
    .grid__item {
      grid-column: span 3;
    }
  }
  .card {
    &-top {
      .day {
        display: none;
      }
    }

    .data-news-decr {
      display: block;
      color: rgba(205, 205, 205, 0.5);
      font-size: 0.88em;
      font-weight: bold;
      text-align: right;
      line-height: 2;
    }
    &__descr {
      height: 35vw;
      margin: 0;
      padding: 0;
      display: flex;
      justify-content: flex-end;
      flex-direction: column;
      .overlay {
        padding: 0.5rem 1rem;
        background: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0) 0%,
          rgba(3, 3, 3, 0.6) 67.71%
        );
        backdrop-filter: blur(0px);
      }
    }
    &__brief {
      display: none;
    }
  }
}
@media screen and (max-width: 767px) {
  .fivth-bar {
    width: 100%;
  }
  .grid {
    width: 100%;
    grid-template-columns: repeat(1, 1fr);
    gap: 1.6rem;
    &__item {
      grid-column: span 1;
      height: 57vw;
    }
  }

  .card {
    justify-content: center;
    .overlay {
      background: rgba(248, 248, 248, 0.7);
      height: 100%;
    }
    &__descr {
      padding-top: 0;
      padding-bottom: 0;
      color: #121212;
      justify-content: center;
      width: 90%;
      margin: 0 auto;
      .card-top {
        justify-content: center;
      }
    }
    &__title {
      text-align: center;
    }
    &__category,
    .data-news-decr {
      color: rgba(18, 18, 18, 0.5) !important;
    }
  }
}
p::first-letter {
  color: #961964;
  font-weight: bold;
}
</style>
